import {
  Timer, Users, Award, Shield,
  User, Palette, Heart, Flag, Target, Star,
} from 'lucide-react';

// Custom football icon (not available in lucide)
export const Football = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2c0 0-3 4-3 10s3 10 3 10" />
    <path d="M12 2c0 0 3 4 3 10s-3 10-3 10" />
    <path d="M2 12h20" />
  </svg>
);

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_864cc152-5d80-4928-acac-3bcce367b776/artifacts/dhju5nz8_Grassroots%20Coach%20Logo%20260329.png";
export const LOGO_URL_DARK = "https://customer-assets.emergentagent.com/job_52a257a5-c44c-4778-ac7b-ede189fa6bbe/artifacts/o52qm2w6_GC%20White%20Logo%200105%20%282%29.png";
export const LOGO_URL_TINTED = "https://customer-assets.emergentagent.com/job_8ba52e1c-a582-4111-b0e4-e9243b3a71e0/artifacts/dvnu6km9_GC%20White%20Logo%200105%20%282%29.png";

export const STORAGE_KEY = 'gc_onboarding_progress';

export const ICON_MAP = {
  timer: Timer, award: Award, users: Users, shield: Shield,
  user: User, palette: Palette, star: Star, heart: Heart,
  flag: Flag, target: Target, football: Football,
};

export const ICON_BG_MAP = {
  emerald: { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  blue: { bg: 'bg-blue-100', text: 'text-blue-700' },
  purple: { bg: 'bg-purple-100', text: 'text-purple-700' },
  amber: { bg: 'bg-amber-100', text: 'text-amber-700' },
  red: { bg: 'bg-red-100', text: 'text-red-700' },
  pink: { bg: 'bg-pink-100', text: 'text-pink-700' },
  indigo: { bg: 'bg-indigo-100', text: 'text-indigo-700' },
  teal: { bg: 'bg-teal-100', text: 'text-teal-700' },
};

export const PRESET_COLORS = [
  { name: 'Green', value: '#064E3B' },
  { name: 'White', value: '#F8FAFC' },
  { name: 'Gold', value: '#D4AF37' },
  { name: 'Black', value: '#000000' },
  { name: 'Claret', value: '#7B1A38' },
  { name: 'Red', value: '#991B1B' },
  { name: 'Blue', value: '#1E40AF' },
  { name: 'Orange', value: '#EA580C' },
];
